/**
 * @prettier
 *
 * Displays landing page for newly created + authenticated users
 *
 * @author Alexander Nagelberg
 *
 * @prop {Object} completeRegistration - action to complete registration on backend
 * @prop {Object} user - (redux) user object from lgyStore
 *
 * @example
 * <LandingPage />
 *
 */
import React from 'react'
import { connect } from 'react-redux'

import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import { completeRegistration } from '../actions/landingActions'

const LandingPage = ({ completeRegistration, user }) => (
  <div className='lgy-landingpage'>
    {user.error && (
      <LgyAlertDialog type='error' heading='Error Registering' paragraph>
        There was an error completing registration: {user.errors[0]?.message ?? 'error not found'}
      </LgyAlertDialog>
    )}
    <LgyAlertDialog id='landing-info' type='info' heading='Welcome to LGY Hub!'>
      <p>
        To complete your registration, you will need to click on the Complete Registration button below and enter both
        your contact and affiliate information. In the future, to update that information, please click on your name in
        the upper right of this page, and it will take you to your user profile where those pages are.
      </p>
      <p>
        If you select the Help link, it will take you to frequently asked questions (FAQ) as well as give you the
        ability to enter a help ticket for access issues or other problems with your account.
      </p>
      <p>Please discuss all business-related, loan, or funding fee matters with your VA RLC (Regional Loan Center).</p>
      <p>
        <b>Notes:</b>
      </p>
      <p>
        If you are a lender or servicer role/affiliate, your employer company admin must activate your account to give
        you access to LGY applications.
      </p>
      <p>
        All affiliates other than lenders and servicers must complete a form and provide it to your regional loan center
        (RLC) before registration. If you have already completed that form and obtained your ID with the VA, you will be
        active once you complete your registration. Please see this link for a list of RLC's to find the one for your
        state:{' '}
        <a target='_blank' rel='noopener noreferrer' href='https://www.benefits.va.gov/HOMELOANS/contact_rlc_info.asp'>
          https://www.benefits.va.gov/HOMELOANS/contact_rlc_info.asp
        </a>
        .
      </p>
      <p>
        Always log-on to LGY Hub/ID.me starting at{' '}
        <a target='_blank' rel='noopener noreferrer' href='https://lgy.va.gov'>
          https://lgy.va.gov
        </a>
        .
      </p>
      <button onClick={completeRegistration}>Complete Registration</button>
    </LgyAlertDialog>
  </div>
)

const mapStateToProps = state => ({
  user: state.currentUser
})

export default connect(mapStateToProps, { completeRegistration })(LandingPage)
